exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#forgot-password-form .forgot-password-action-bar {\n  background-color: inherit;\n  text-align: left; }\n\n#forgot-password-form .forgot-password-form-button {\n  width: 100%; }\n\n#forgot-password-form .forgot-password-title {\n  font-weight: normal;\n  margin: 0px 0px 20px;\n  text-align: left; }\n\n#forgot-password-form .forgot-password-input-group {\n  max-width: none; }\n  #forgot-password-form .forgot-password-input-group .forgot-password-input-tag {\n    width: 100%; }\n\n#forgot-password-form .ssg-forms-required-indicator {\n  display: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/acct/password/forgot-password.component.scss
// module id = 1344
// module chunks = 0